<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Mail Grubu Düzenle</h4>
              <p class="card-category">Mail grubu içerisindeki mail adresleri bu mail grubu ile gönderilecektir.</p>
            </template>


            <form class="m-5">
              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Grup İsmi" placeholder="Grup İsmi" v-model="payload.title">
                  </base-input>
                </div>
              </div>


              <div class="row">
                <div class="col-md-12">
                  <base-checkbox v-model="payload.isActive">
                    Aktif
                  </base-checkbox>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <base-checkbox v-model="payload.isSpecialGroup">
                  Özel Grup Mu?
                </base-checkbox>
              </div>
            </div>
            <label>Özel olan gruba ait mailler, başka bir özel gruba aktif olarak eklenemez. </label>




              <div class="text-center">
                <button type="submit" class="btn btn-info btn-fill float-right" @click="updateMail()">
                  Güncelle
                </button>
              </div>
              <div class="clearfix"></div>
            </form>

          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";
export default {
  components: {
    Card
  },
  data() {
    return {
      id: null,
      payload: {
      }
    }
  },
  mounted() {
    this.id = window.location.href.split('/').at(-1);
    this.getFromMail();
  },
  methods: {
    updateMail() {
      CollectionService.updateCollectionItem('mailgroup', this.id, this.payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Mail Grubu Güncellendi")
          this.$router.push(`/admin/mailgroups`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    getFromMail() {

      CollectionService.getCollectionItemWithId('mailgroup', this.id).then((res) => {
        if (res.success == true) {
          console.log(res.f)
          this.payload = res.mailGroup;
          console.log(this.payload)
        } else {
          console.log('error');
        }
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    }
  }
}
</script>
<style></style>